import { createContext } from 'react'
import { DashboardType } from 'redux/ReportingDashboard/reducers/filtersReducer'

export const DashboardTypeContext = createContext<DashboardType>('filtersMedia')
